import React, { useCallback, useState } from 'react';

import { DeleteOutlined as TrashOutlineIcon } from '@ant-design/icons';
import { Button } from 'antd';

import AlpaclassForm from '../../Form/Alpaclass';

interface IProps {
  other: any;
  onRemove: any;
  onEdit?: any;
  index: any;
  offer?: any;
}

const Alpaclass: React.FC<IProps> = ({ other, onRemove, onEdit, index, offer }) => {
  const [modal, setModal] = useState(false);
  const otherName = (item: any) => (item?.id ? item.method_name : item.name);
  const toggleModal = useCallback(() => {
    setModal(prev => !prev);
  }, []);
  const onOk = useCallback(
    (newItem: any, old: any) => {
      setModal(false);
      if (onEdit) onEdit(newItem, old);
    },
    [onEdit]
  );

  return (
    <>
      <li
        className='flex cursor-pointer items-center gap-3 border-b border-gray-200 px-4 py-2 hover:bg-gray-50'
        onClick={() => toggleModal()}
      >
        <img src='/img/alpaclass.svg' width='28' />
        <div className='flex-1'>
          <div className='font-medium'>{otherName(other)}</div>
          <div className='text-sm text-gray-500'>{other?.url}</div>
        </div>
        {other.can_modify && (
          <Button
            type='text'
            icon={<TrashOutlineIcon />}
            onClick={e => {
              e.stopPropagation();
              onRemove(otherName(other), index);
            }}
          />
        )}
      </li>
      {modal && (
        <AlpaclassForm other={other} isModal={true} open={modal} onClose={toggleModal} onOk={onOk} offer={offer} />
      )}
    </>
  );
};

export default Alpaclass;
